"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StockedProduct = void 0;
const class_validator_1 = require("class-validator");
const Product_1 = require("./Product");
const TProductType_1 = require("../types/TProductType");
const trt_1 = require("../helpers/trt");
/**
 * Stocked Products are goods that can be sold as is and are not
 * customisable. For example, Pepsi drinks.
 */
class StockedProduct extends Product_1.Product {
    constructor() {
        super(...arguments);
        this.category = Product_1.defaultProductCategory;
    }
    get isOutOfStock() {
        return this.currentStockLevel <= 0;
    }
    get type() {
        return TProductType_1.TProductType.StockedProduct;
    }
    // TODO: move to zam specific
    hasValidTrtProduct(validProductTrtIds) {
        return (0, trt_1.isValidTrtId)(this.trtId, validProductTrtIds);
    }
    filterSensitiveData() {
        const clone = super.filterSensitiveData();
        // TODO: move to zam specific
        delete clone.trtId;
        return clone;
    }
    serialize() {
        return Object.assign(Object.assign({}, super.serialize()), { retailLocationId: this.retailLocationId, currentStockLevel: this.currentStockLevel, isStandalone: this.isStandalone, category: this.category, 
            // TODO: move to zam specific
            trtId: this.trtId });
    }
    static unserialize(data) {
        const newStockedProduct = new StockedProduct();
        newStockedProduct.productId = data.productId;
        newStockedProduct.retailLocationId = data.retailLocationId;
        newStockedProduct.title = data.title;
        newStockedProduct.description = data.description;
        newStockedProduct.imageUrl = data.imageUrl;
        newStockedProduct.retailPrice = data.retailPrice;
        newStockedProduct.retailLocationId = data.retailLocationId;
        newStockedProduct.currentStockLevel = data.currentStockLevel;
        newStockedProduct.isStandalone = data.isStandalone;
        newStockedProduct.category = data.category;
        newStockedProduct.dietaryInfo = data.dietaryInfo;
        // TODO: move to zam specific
        newStockedProduct.trtId = data.trtId;
        return newStockedProduct;
    }
}
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsPositive)(),
    (0, class_validator_1.IsNotEmpty)()
], StockedProduct.prototype, "currentStockLevel", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsNotEmpty)()
], StockedProduct.prototype, "isStandalone", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)()
], StockedProduct.prototype, "category", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)()
], StockedProduct.prototype, "trtId", void 0);
exports.StockedProduct = StockedProduct;
//# sourceMappingURL=StockedProduct.js.map